import { render } from "./ColorScale.vue?vue&type=template&id=2cbc99f0&scoped=true"
import script from "./ColorScale.vue?vue&type=script&lang=js"
export * from "./ColorScale.vue?vue&type=script&lang=js"

import "./ColorScale.vue?vue&type=style&index=0&id=2cbc99f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cbc99f0"]])

export default __exports__